var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Container",
    clipPath: "url(#clip0_290_392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cloud",
    d: "M30.3425 12.7312V12.4977C30.3425 5.96027 25.206 0.82373 18.6686 0.82373C12.8316 0.82373 7.92853 5.02636 7.22809 10.8633C3.02546 12.2642 -0.00976562 15.9999 -0.00976562 20.6695C-0.00976562 26.5064 4.65982 31.176 10.4968 31.176C14.4659 31.176 24.2721 31.176 28.0077 31.176C33.1443 31.176 37.3469 26.9734 37.3469 21.8369C37.3469 17.4008 34.3117 13.8986 30.3425 12.7312Z",
    fill: "#A20B91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 2",
    d: "M21.0031 19.5021V26.5064H16.3335V19.5021H9.3291L18.6683 10.1629L28.0074 19.5021H21.0031Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.3567,
    height: 30.3523,
    fill: "white",
    transform: "translate(-0.00976562 0.82373)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f75e1ed82eb0b8160a4711e03e9b03c1.svg";
export { ForwardRef as ReactComponent };